import "./card.scss";

const Card = ({ title, disabled, icon }) => {
  return (
    <div
      className="items-1 w-100"
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        filter: disabled ? "blur(2px)" : "none",
      }}
    >
      <div className="icon-wrapper-1">{icon}</div>
      <div className="project-name-1">
        <p>{title}</p>
      </div>
    </div>
  );
};

export default Card;
